import React from "react";
import { Container, Row, Col } from "shards-react";
import ClientInvoicingConfigs from "../components/contacts/ClientInvoicingConfigs";

const ClientInvoicingConfigsView = props => {
  const { id } = props.match.params;
  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <ClientInvoicingConfigs client_id={id} />
    </Container>
  );
};

export default ClientInvoicingConfigsView;
